import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_POINTS_EARN_CALCULATION_BATCH } from 'actions/apiActionConstants'
import { requestLoyaltyEarnPointsCalculationBatch } from 'api/loyalty/requestLoyaltyEarnPointsCalculationBatch'
import buildPointsKey from 'loyalty/lib/pointsCalculation/buildPointsKey'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import { getHasLuxPlusOrSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscription'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'

export default function submitLoyaltyPointsEarnCalculationBatchRequest(
  calculationRequests: Array<App.LoyaltyPointsEarnCalculationRequest>,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const customerId = state.auth.account.memberId ?? ''
    const currency = state.geo.currentCurrency
    const hasLuxPlusOrSubscriptionInCart = getHasLuxPlusOrSubscriptionInCart(state)
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const isCurrentRegionUserLoyaltyRegion = getIsCurrentRegionUserLoyaltyRegion(state)

    if (
      !getIsLoyaltyEnabled(state) ||
      (hasLoyaltyAccount && !isCurrentRegionUserLoyaltyRegion) ||
      calculationRequests.length === 0
    ) return

    const newRequests = calculationRequests.filter(req => {
      const key = buildPointsKey(req, customerId)
      const existing = state.loyalty.pointsEarnCalculations[key]
      return !(existing?.data || existing?.fetching || existing?.error)
    })

    if (newRequests.length === 0) return

    const pointsEarnCalculationKeys = newRequests.map(req => buildPointsKey(req, customerId))

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_POINTS_EARN_CALCULATION_BATCH,
      pointsEarnCalculationKeys,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
      request: () => requestLoyaltyEarnPointsCalculationBatch(newRequests, {
        customerId,
        currency,
        luxPlusMember: hasLuxPlusOrSubscriptionInCart,
      }),
    })
  }
}
